import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PictureShape from '../../../shapes/Picture';
import { isEmpty } from '../../../core/util/empty';
import { THUMBNAIL_SMALL } from './util';

class Picture extends Component {
  static propTypes = {
    imageObject: PictureShape,
    imgTag: PropTypes.any,
    className: PropTypes.string,
    showThumbnail: PropTypes.bool,
    thumbnailSize: PropTypes.string,
  };

  render() {
    const {
      imageObject: { webp, jp2, fullRes, thumbnail128, thumbnail200 },
      imgTag,
      className,
      showThumbnail,
      thumbnailSize,
      ...imageProps // jscs: disable
    } = this.props;
    const ImgTag = imgTag || 'img';

    if (showThumbnail && thumbnailSize === THUMBNAIL_SMALL && !isEmpty(thumbnail128)) {
      return <ImgTag className={className} {...imageProps} src={thumbnail128} />;
    }

    if (showThumbnail && !isEmpty(thumbnail200)) {
      return <ImgTag className={className} {...imageProps} src={thumbnail200} />;
    }

    return (
      <picture className={className}>
        {webp && <source type="image/webp" srcSet={webp} />}
        {jp2 && <source type="image/jp2" srcSet={jp2} />}
        {fullRes && <ImgTag className={className} {...imageProps} src={fullRes} />}
      </picture>
    );
  }
}

export default Picture;
